export type Size = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'

const sizes: Readonly<Record<Size, number>> = {
  xxs: 320,
  xs: 500,
  sm: 700,
  md: 900,
  lg: 1224,
  xl: 1400,
  xxl: 1800,
  xxxl: 2400,
}
// eslint-disable-next-line no-type-assertion/no-type-assertion
// eslint-disable-next-line no-type-assertion/no-type-assertion
export const screensMin = Object.fromEntries(
  Object.entries({ ...sizes }).map(([key, size]) => [key, `(min-width: ${size / 16}em)`])
) as Record<Size, string>

// eslint-disable-next-line no-type-assertion/no-type-assertion
export const screensMax = Object.fromEntries(
  Object.entries({ ...sizes }).map(([key, size]) => [key, `(max-width: ${(size - 1) / 16}em)`])
) as Record<Size, string>
